// src/pages/ExamSystemPage.jsx
import React from "react";
import ExamSystem from "../../ChatWithAI/ExamSystem";
import "./ExamsQuizzes.css";

const ExamsQuizzes = () => {
  return (
    <div className="exam-system-page">
      <div className="page-header">
        <span className="exam-system-header">Prepare Yourself Today</span>
        <span className="exam-system-subHeader">Select Educations Level, Class & Subject to start your generated exam</span>
      </div>
      <ExamSystem />
    </div>
  );
};

export default ExamsQuizzes;
